import styled from "styled-components";

export const StyledTable = styled.div`
  & th {
    background-color: ${({ theme }) => theme.sportNonLive.HeaderBackground};
    color: white; // TODO: we will add this one to theme object later
    font-size: 14px;
    border: 1px solid ${({ theme }) => theme.sportNonLive.Border};
    padding: 8px;
  }

  & td {
    border: 1px solid ${({ theme }) => theme.sportNonLive.Border};
    padding: 8px;
    font-size: 14px;
    white-space: pre-wrap;
  }

  & th.league {
    background-color: ${({ theme }) =>
      theme.sportNonLive.TitleLeagueBackground};
  }

  & tr.even-row {
    background-color: ${({ theme }) => theme.sportNonLive.TableBackground};
  }

  & tr.odd-row {
    background-color: ${({ theme }) => theme.sportNonLive.TableHardBackground};
  }

  & td:nth-last-child(-n + 2) {
    text-align: center;
    vertical-align: middle;
  }

  & td:first-child {
    vertical-align: middle;
  }

  & .period-results-scroll {
    overflow-x: auto;
  }

  & .period-results {
    min-width: 920px;
    border-collapse: collapse;
  }

  & .period-results th {
    white-space: nowrap;
  }

  & .period-results .period-date {
    width: 160px;
    text-align: center;
    white-space: nowrap;
  }

  & .period-results .period-team {
    min-width: 220px;
    text-align: left;
  }

  & .period-results .period-score {
    min-width: 56px;
    text-align: center;
    vertical-align: middle;
  }

  & .handball-results-scroll {
    overflow-x: auto;
  }

  & .handball-results {
    min-width: 560px;
    border-collapse: collapse;
  }

  & .handball-results thead th {
    text-align: left;
  }

  & .handball-results thead th:last-child {
    text-align: center;
  }

  & .handball-results .handball-date {
    width: 160px;
    white-space: nowrap;
  }

  & .handball-results .handball-match {
    text-align: left;
  }

  & .handball-results .handball-final {
    width: 100px;
    text-align: center;
    white-space: nowrap;
  }
`;
